import { render, staticRenderFns } from "./Developers.vue?vue&type=template&id=1ddff4e5"
import script from "./Developers.vue?vue&type=script&lang=js"
export * from "./Developers.vue?vue&type=script&lang=js"
import style0 from "./Developers.vue?vue&type=style&index=0&id=1ddff4e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports